<template>
  <div class="content" v-if="show" @touchmove.prevent>
    <Header title="区号选择" @toBack="toBack"></Header>
    <!-- 列表 -->
    <div class="list" @touchmove.stop>
      <div class="oneBox">
        <div class="font3">{{ arrObj.name }}（当前选择）</div>
        <div class="font3">{{ arrObj.tel }}</div>
      </div>
      <div
        class="recordBox"
        v-for="(item, index) in codeList"
        :key="index"
        @click="toCheck(item)"
      >
        <div class="font">{{ item.name }}</div>
        <div class="font2">{{ item.tel }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/NavTopLogin/index.vue'
export default {
  name: 'pcodeCheck',
  components: {
    Header,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String,
      default: '+86',
    },
    codeList:{
      type:Array,
      default:[],
    },
  },
  data() {
    return {
      arrObj: {},
      iShow: true,
    }
  },
  watch: {
    deviceClass() {
      if (this.deviceClass == 'pc') {
        window.location.replace(
          `${this.$glb.feemooUrl}/login?path=drive`
        )
      }
    },
    show() {
      this.arrObj = this.codeList.find(item => item.tel == this.code)
    },
  },
  mounted() {
    if (this.deviceClass == 'pc') {
      window.location.replace(`${this.$glb.feemooUrl}/login?path=drive`)
    }
  },
  computed: {
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
  },
  methods: {
    //返回
    toBack() {
      this.$emit('close')
    },
    toCheck(item) {
      this.$emit('toCheck', item.tel)
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  overflow: auto;
  height: 100vh;
  overflow-x: hidden;
  scrollbar-width: none;
  position: fixed;
  z-index: 100;
  width: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    display: none;
  }
  &::-webkit-scrollbar-track {
    display: none;
  }
  .list {
    padding: 14px 20px;
    overflow: auto;
    padding-bottom: 100px;
    -webkit-overflow-scrolling: touch;
    /* 关键样式 */
    touch-action: pan-y; /* 启用垂直滚动 */
    .oneBox {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 16px 0;
      box-shadow: inset 0px -1px 0px 0px #efefef;

      .font3 {
        font-weight: 500;
        font-size: 12px;
        color: #8a8b92;
        line-height: 16px;
      }
    }
    .recordBox {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 12px 0;
      box-shadow: inset 0px -1px 0px 0px #efefef;

      .font {
        font-weight: 400;
        font-size: 16px;
        color: #2c2c2c;
        line-height: 24px;
      }

      .font2 {
        font-weight: 400;
        font-size: 16px;
        color: #8a8b92;
        line-height: 24px;
      }
    }
  }
}
</style>
